import { Box, BoxProps, Flex, FlexProps } from '@chakra-ui/react'
import { t } from 'i18next'
import { FolderOpen } from 'lucide-react'
import React from 'react'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'
import { ApiError } from '@mangovoice/types'

const ResourceFailedToLoadNoticeWrapper = ({
  children,
  ...props
}: React.PropsWithChildren<FlexProps>) => (
  <Flex
    flex={1}
    alignItems="center"
    justifyContent="center"
    width="100%"
    userSelect="none"
    backgroundColor={'bg.subtle'}
    {...props}
  >
    {children}
  </Flex>
)

const ImageWrapper = ({
  children,
  ...props
}: React.PropsWithChildren<BoxProps>) => (
  <Box marginBottom="26px" {...props}>
    {children}
  </Box>
)

const ResourceFailedToLoadContentWrapper = ({
  children,
  ...props
}: React.PropsWithChildren<FlexProps>) => (
  <Flex flexDirection="column" alignItems="center" {...props}>
    {children}
  </Flex>
)

const ResourceFailedToLoadTextWrapper = ({
  children,
  ...props
}: React.PropsWithChildren<FlexProps>) => (
  <Flex
    alignItems="flex-start"
    justifyContent="center"
    height="62px"
    width="875px"
    {...props}
  >
    {children}
  </Flex>
)

const handleErrorText = (error?: ApiError) => {
  return (
    <Flex
      flexDirection={'column'}
      width={'100%'}
      alignItems={'center'}
      justifyContent={'center'}
    >
      <Flex
        {...textStyles[textStyleKeys.Body1_Bold]}
        color={'fg.default'}
        textAlign={'center'}
      >
        {(() => {
          if (error?.status === 403) {
            return t(
              'resourceFailedToLoad.permission',
              "You don't have permission to access this voicemail box",
            )
          } else if (error?.status === 410) {
            return t('resourceFailedToLoad.deleted', 'Voicemail deleted')
          } else {
            return t(
              'resourceFailedToLoad.unavailable',
              'Voicemail unavailable',
            )
          }
        })()}
      </Flex>
      <Flex
        {...textStyles[textStyleKeys.Body1]}
        color={'fg.default'}
        textAlign={'center'}
      >
        {error?.status === 403
          ? t(
              'resourceFailedToLoad.contactAdmin',
              'To get access, contact your system administrator',
            )
          : ''}
      </Flex>
    </Flex>
  )
}

export const ResourceFailedToLoadNotice = ({ error }: { error?: ApiError }) => {
  return (
    <ResourceFailedToLoadNoticeWrapper>
      <ResourceFailedToLoadContentWrapper>
        <ImageWrapper>
          <FolderOpen size={49} />
        </ImageWrapper>
        <ResourceFailedToLoadTextWrapper>
          {handleErrorText(error)}
        </ResourceFailedToLoadTextWrapper>
      </ResourceFailedToLoadContentWrapper>
    </ResourceFailedToLoadNoticeWrapper>
  )
}
